module.exports = __webpack_public_path__ + "public/1.0.1_200686/img/双摄模组1.2316f8a1.png";